// extracted by mini-css-extract-plugin
module.exports = {"textareaStyle":"teamList_textareaStyle__3Xw9i"};